import { useEffect } from "react";

const SITE = "https://hights.uk";

export function SEO({ title, description, path = "/", jsonLd = null }) {
    useEffect(() => {
        if (title) document.title = title;
        const setMeta = (attr, key, content) => {
            let el = document.head.querySelector(`meta[${attr}="${key}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
        }
        if (title) setMeta("property", "og:title", title);
        setMeta("property", "og:url", `${SITE}${path}`);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE}${path}`);
        let ld = document.getElementById("page-jsonld");
        if (jsonLd) {
            if (!ld) {
                ld = document.createElement("script");
                ld.type = "application/ld+json";
                ld.id = "page-jsonld";
                document.head.appendChild(ld);
            }
            ld.textContent = JSON.stringify(jsonLd);
        } else if (ld) {
            ld.remove();
        }
    }, [title, description, path, jsonLd]);
    return null;
}
